import ExchangeRateResource from "@/module/Form/Resources/ExchangeRateResource";

export default class ExchangeRateProvider {
  private readonly _exchangeRates: ExchangeRateResource[];
  private _importedExchangeRates: ExchangeRateResource[] = [];
  private readonly formUrl: string;
  private readonly formPath: string;
  private readonly targetCurrency: string;

  constructor(
    exchangeRates: ExchangeRateResource[],
    formUrl: string,
    formPath: string,
    targetCurrency: string,
  ) {
    this.formUrl = formUrl;
    this.formPath = formPath;
    this._exchangeRates = exchangeRates;
    this.targetCurrency = targetCurrency;
  }

  get exchangeRates(): ExchangeRateResource[] {
    return this._exchangeRates;
  }

  findBySourceCurrency(
    sourceCurrency: string,
  ): ExchangeRateResource | undefined {
    return this._exchangeRates.find((item) => {
      return item.source_currency === sourceCurrency;
    });
  }

  async findBySourceCurrencyOrImport(
    sourceCurrency: string,
  ): Promise<ExchangeRateResource | undefined> {
    let exchangeRate = this.findBySourceCurrency(sourceCurrency);

    if (exchangeRate !== undefined) {
      return exchangeRate;
    }

    exchangeRate = this.findBySourceCurrencyInImported(sourceCurrency);

    if (exchangeRate !== undefined) {
      return exchangeRate;
    }

    return this.importExchangeRate(sourceCurrency);
  }

  hasExchangeRate(sourceCurrency: string) {
    return this.findBySourceCurrency(sourceCurrency) !== undefined;
  }

  private findBySourceCurrencyInImported(
    sourceCurrency: string,
  ): ExchangeRateResource | undefined {
    return this._importedExchangeRates.find((item) => {
      return item.source_currency === sourceCurrency;
    });
  }

  private importExchangeRate(
    sourceCurrency: string,
  ): Promise<ExchangeRateResource> {
    return fetch(
      this.formUrl +
        "/get-exchange-rate?id=" +
        this.formPath +
        "&sourceCurrency=" +
        sourceCurrency +
        "&targetCurrency=" +
        this.targetCurrency,
      {
        credentials: "omit",
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((exchangeRateResource: ExchangeRateResource) => {
        this._importedExchangeRates.push(exchangeRateResource);

        return exchangeRateResource;
      });
  }
}
